import React from 'react';

const LoginFieldError = ({ message }) => {
  if (!message) return null;

  return (
    <div className='login-field-error' role='alert'>
      <i className='ri-error-warning-line' />
      <span>{message}</span>
    </div>
  );
};

export default LoginFieldError;
